import React, { FC } from "react";
import {
  Button,
  Popconfirm,
  Space,
  Table,
  TablePaginationConfig,
  Tooltip,
} from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

import { IAdminInfo } from "types/administration.types";
import { useAppSelector } from "store";
import { tokenInfoSelector } from "store/auth/auth.selectors";
import { roleOptions, ROLES } from "constants/roles";

type AdministrationTableProps = {
  data: IAdminInfo[];
  loading: boolean;
  pagination: TablePaginationConfig;
  onChange: (pagination: TablePaginationConfig, filters: any) => void;
  onEdit: (data: IAdminInfo) => void;
  onDelete: (data: IAdminInfo) => Promise<any>;
};

export const AdministrationTable: FC<AdministrationTableProps> = ({
  pagination,
  loading,
  data,
  onChange,
  onEdit,
  onDelete,
}) => {
  const tokenInfo = useAppSelector(tokenInfoSelector);
  return (
    <Table
      rowKey="id"
      loading={loading}
      pagination={pagination}
      dataSource={data}
      onChange={onChange}
      scroll={{ x: "max-content" }}
      columns={[
        {
          dataIndex: "email",
          title: "Логин (email)",
          align: "center",
        },
        {
          dataIndex: "role",
          title: "Роль",
          align: "center",
          render: (val) =>
            roleOptions.find(({ value }) => value === val)?.label || val,
        },
        {
          title: "Фамилия Имя Отчество",
          render: (_, { surname, name, patronymic }) =>
            `${surname} ${name} ${patronymic}`,
          align: "center",
        },
        {
          dataIndex: "createdAt",
          title: "Дата создания",
          render: (_, { createdAt }) => dayjs(createdAt).format("DD.MM.YYYY"),
          align: "center",
        },
        {
          title: "Действия",
          align: "center",
          render: (_, data) => {
            const isSelf = data.id === tokenInfo?.id;
            return (
              <Space>
                {!isSelf && (
                  <Tooltip title="Редактировать">
                    <Button
                      type="text"
                      icon={<EditOutlined />}
                      onClick={() => onEdit(data)}
                    />
                  </Tooltip>
                )}
                {data.role !== ROLES.ROLE_ADMIN && !isSelf && (
                  <Popconfirm
                    placement="topRight"
                    title="Подтвердите действие"
                    onConfirm={() => onDelete(data)}
                    zIndex={2}
                    okText={""}
                    cancelText={""}
                    okButtonProps={{
                      icon: <CheckOutlined />,
                      size: "small",
                      danger: true,
                    }}
                    cancelButtonProps={{
                      icon: <CloseOutlined />,
                      size: "small",
                    }}
                  >
                    <Tooltip title="Удалить" zIndex={1}>
                      <Button
                        type="text"
                        icon={<DeleteOutlined />}
                      />
                    </Tooltip>
                  </Popconfirm>
                )}
              </Space>
            );
          },
        },
      ]}
    />
  );
};
